module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "top": "0px",
      "right": "0px"
    }
  }, [(_vm.getScratchPad.length === 0) ? _c('div', {
    staticClass: "flexContainer abs full",
    attrs: {
      "id": "noResults"
    }
  }, [_c('h3', {
    staticClass: "uppercase txtCenter"
  }, [_vm._v(_vm._s(_vm.$t("scratchPad.noScratch")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scrollY flexContainer fw-w",
    attrs: {
      "id": "scratchContent"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-638ed126","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/ScratchPad.vue
// module id = 3229
// module chunks = 0